module.exports = __webpack_public_path__ + "img/bank-add-transaction.253124c5.svg";